<div class="confirm-photo">
  <p translate>confirm-valid-id.component.confirm-label</p>

  <div class="checkbox control">
    <input id="validDocument" type="checkbox" [formControl]="validDocument" />
    <label for="validDocument" translate>confirm-valid-id.component.confirm-valid</label>
  </div>

  <div class="checkbox control">
    <input id="legibleDocument" type="checkbox" [formControl]="legibleDocument" />
    <label for="legibleDocument" translate>confirm-valid-id.component.confirm-legible</label>
  </div>

  <div [innerHtml]="'confirm-valid-id.component.confirm-retake' | translate"></div>
  <div [innerHtml]="'confirm-valid-id.component.' + label | translate"></div>
</div>
